
import React from "react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

interface BunkerScoreButtonsProps {
  onScoreChange: (score: number) => void;
}

const BunkerScoreButtons: React.FC<BunkerScoreButtonsProps> = ({ onScoreChange }) => {
  const { t } = useTranslation('training');
  
  const buttonVariants = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
  };

  return (
    <div className="grid grid-cols-1 gap-2">
      <motion.div variants={buttonVariants} whileHover="hover" whileTap="tap">
        <Button
          onClick={() => onScoreChange(6)}
          className="h-14 bg-green-600 hover:bg-green-700 w-full text-base font-bold text-white"
        >
          {t('interface.scoring.bunker.ballIn')} (6 pts)
        </Button>
      </motion.div>
      <motion.div variants={buttonVariants} whileHover="hover" whileTap="tap">
        <Button
          onClick={() => onScoreChange(4)}
          className="h-14 bg-green-500 hover:bg-green-600 w-full text-base font-bold text-white"
        >
          {t('interface.scoring.bunker.at05m')} (4 pts)
        </Button>
      </motion.div>
      <motion.div variants={buttonVariants} whileHover="hover" whileTap="tap">
        <Button
          onClick={() => onScoreChange(3)}
          className="h-14 bg-blue-500 hover:bg-blue-600 w-full text-base font-bold text-white"
        >
          {t('interface.scoring.bunker.at1m')} (3 pts)
        </Button>
      </motion.div>
      <motion.div variants={buttonVariants} whileHover="hover" whileTap="tap">
        <Button
          onClick={() => onScoreChange(2)}
          className="h-14 bg-yellow-500 hover:bg-yellow-600 w-full text-base font-bold text-white"
        >
          {t('interface.scoring.bunker.at2m')} (2 pts)
        </Button>
      </motion.div>
      <motion.div variants={buttonVariants} whileHover="hover" whileTap="tap">
        <Button
          onClick={() => onScoreChange(0)}
          className="h-14 bg-red-500 hover:bg-red-600 w-full text-base font-bold text-white"
        >
          {t('interface.scoring.bunker.outsideCircles')} (0 pt)
        </Button>
      </motion.div>
    </div>
  );
};

export default BunkerScoreButtons;
